import React from 'react';
import {DragLayer} from 'react-dnd';
import PropTypes from 'prop-types';

import {DragDropType} from '../../../constants/dataEnum';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

function getItemStyles(props) {
  const {initialOffset, currentOffset} = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }
  const {x, y} = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}
function CustomDragLayer(props) {
  const {itemType, isDragging, draggedLayout} = props;

  function renderItem() {
    const element = draggedLayout?.draggedElement;
    switch (itemType) {
      case DragDropType.TRANSFORM_SELECTION:
        return <div style={{width: element?.width || 0, height: element?.height || 0, border: 'solid 2px #0059CC'}} />;
      default:
        return null;
    }
  }
  if (!isDragging) {
    return null;
  }

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(props)}>{renderItem()}</div>
    </div>
  );
}

CustomDragLayer.propTypes = {
  itemType: PropTypes.string,
  isDragging: PropTypes.bool.isRequired,
  draggedLayout: PropTypes.object.isRequired,
};

CustomDragLayer.defaultProps = {
  itemType: '',
};

export default DragLayer((monitor) => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging(),
}))(CustomDragLayer);
